'use strict';

angular.module('sharecrf.loading')
    .component('sharecrfLoading', {
        templateUrl: 'modules/loading/components/sharecrf-loading/template.html',
        controller: 'ShareCrfLoadingController',
    });
